import { TextFieldProps, Theme } from '@mui/material'

export const overwriteMinimalTableTableBodyStyle = {
  sx: (theme: Theme) => ({
    '& tr:hover > td:after': {
      backgroundColor: theme.palette.grey[100],
      '& .Mui-TableHeadCell-Content': {
        display: 'flex',
        width: '100%',
      },
      '& .Mui-TableHeadCell-Content-Labels': {
        display: 'flex',
        width: '100%',
      },
      '& .Mui-TableHeadCell-Content-Wrapper': {
        display: 'flex',
        width: '100%',
      },
    },
  }),
}

export const overwriteMinimalTableHeadCellStyle = (
  isLastPinnedLeft: boolean,
  isControlColumn: boolean,
) => ({
  sx: (theme: Theme) => ({
    backgroundColor: theme.palette.grey[200],
    borderRight: isLastPinnedLeft ? `1px solid ${theme.palette.grey[300]}` : 'none',
    padding: isControlColumn ? '0' : '0.8rem 1rem 0 !important',
    textAlign: isControlColumn ? 'center' : 'left',

    '& .Mui-TableHeadCell-Content': {
      display: 'flex',
      width: '100%',
    },
    '& .Mui-TableHeadCell-Content-Labels': {
      display: 'flex',
      width: '100%',
      fontSize: '0.9rem',
    },
    '& .Mui-TableHeadCell-Content-Wrapper': {
      display: 'flex',
      width: '100%',
    },
    '& .MuiTableSortLabel-root': {
      fontSize: '1rem',
    },

    '& .MuiInputBase-root.MuiSelect-root': {
      maxWidth: '130px',
    },

    '& .Mui-TableHeadCell-Content, & .Mui-TableHeadCell-Content-Labels, & .Mui-TableHeadCell-Content-Wrapper':
      {
        display: 'flex',
        width: '100%',
        textAlign: isControlColumn ? 'center' : 'left',
        alignItems: isControlColumn ? 'center' : 'flex-start',
        justifyContent: isControlColumn ? 'center' : 'flex-start',
      },
  }),
})

export const overwriteMinimalTableMuiSelectCheckboxPropsStyle: { color: 'default'; sx: any } = {
  color: 'default',
  sx: (theme: Theme) => ({
    '&.Mui-disabled': {
      color: theme.palette.grey[400],
    },
  }),
}

export const overwriteMinimalTableDetailPanelStyle = {
  sx: () => ({
    p: '0px',
    borderBottom: `none`,
  }),
}

export const overwriteMinimalTableBodyCellStyle = (
  isLastPinnedLeft: boolean,
  isControlColumn: boolean,
) => ({
  sx: (theme: Theme) => ({
    backgroundColor: theme.palette.common.white,
    borderRight: isLastPinnedLeft ? `1px solid ${theme.palette.grey[300]}` : 'none',
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
    padding: isControlColumn ? '0' : '.5rem 1rem',
    textAlign: isControlColumn ? 'center' : 'left',
  }),
})

export const overwriteMinimalTableToolbarAlertBannerStyle = {
  sx: (theme: Theme) => ({
    backgroundColor: theme.palette.grey[300],
    fontSize: '0.8rem',
    height: '52px',
    '& .MuiAlert-message ': {
      padding: '0.4rem',
      paddingLeft: '10px',
      position: 'fixed',
    },
  }),
}

export const overwriteMinimalTableBodyRowStyle = (isExpanded: boolean, _: boolean) => ({
  sx: (theme: Theme) => ({
    backgroundColor: isExpanded ? theme.palette.common.white : 'current',
    '& td:after': {
      backgroundColor: 'white',
    },
  }),
})

export const overwriteMinimalTableFilterTextFieldProps: TextFieldProps = {
  sx: (theme: Theme) => ({
    m: '0.5rem 0',
    width: '100%',

    '& .MuiInputBase-root.MuiSelect-root': {
      maxWidth: '150px',
    },

    '& .MuiSelect-select': {
      pointerEvents: 'auto',
    },

    '& .MuiInputBase-root:has(.MuiBox-root) .MuiInputAdornment-root': {
      display: 'none',
    },

    '& .MuiSelect-select:not(:has(.MuiBox-root))': {
      paddingRight: '0px !important',
    },

    '& .MuiInputBase-root:not(.MuiSelect-root) .MuiInputBase-input[value=""] + .MuiInputAdornment-root':
      {
        display: 'none',
      },

    '& .MuiSelect-icon': {
      pointerEvents: 'none',
      background: theme.palette.grey[200],
    },

    '& .MuiInputBase-input': {
      fontSize: '0.85rem',
    },
    '& .MuiInputBase-input::placeholder': {
      fontSize: '0.85rem',
    },
  }),
  variant: 'outlined',
  size: 'small',
}
